module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sbox"
  }, [_c('h2', {
    staticClass: "subchapter",
    attrs: {
      "id": "s008"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#s8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bacon and Egg Hash Brown Scramble")])])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/18-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Yield: Serves 8 | Prep Time: 15 minutes | Cook Time: 1 hour")]), _vm._v(" "), _c('p', {
    staticClass: "recipenote"
  }, [_vm._v("“Scramble” is one of my favorite words. You might think chaos and mass confusion, but when it comes to a baked breakfast, that word works well. Inside this mixture are hash browns, bacon, cheddar, and eggs—and when those come together, no order is the order of the day.")])]), _vm._v(" "), _c('p', {
    staticClass: "serves"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "indger1"
  }, [_vm._v("2 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 (10.75-ounce) can cheddar cheese soup")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup evaporated milk")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 tablespoon chopped fresh thyme")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("¼ teaspoon freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 (20-ounce) bag frozen hash browns, thawed")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("6 strips bacon, cooked and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup shredded cheddar cheese")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup corn flakes, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 tablespoons unsalted butter, melted")]), _vm._v(" "), _c('h2', {
    staticClass: "Directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("1. Preheat the oven to 350°F and lightly coat an 8 × 8-inch baking dish with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("2. In a large bowl, beat the eggs until frothy. Add the soup, milk, thyme, salt, and pepper and whisk to mix well. Stir in the hash browns and bacon until well mixed. Pour into the baking dish and top with the cheese. Place the crushed corn flakes in the bowl, add the melted butter, and toss to coat; sprinkle evenly on top of the casserole.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("3. Bake for 1 hour, until puffy and lightly browned on top. Serve.")]), _vm._v(" "), _c('h2', {
    staticClass: "headn"
  }, [_c('strong', [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Evaporated milk will give the mixture a creamier texture, but can be replaced with whole or 2 percent milk.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8baad96a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/s008.vue
// module id = 105
// module chunks = 0